<div class="container-fluid">
    <div *ngIf="!clienteserviceParam.datosCliente.needCoDebtor">
      <hr
          style="text-align: center; background-image: linear-gradient(90deg, #00abb6 15%, #05718f 56%) !important; color: #fff;height: 4px;box-shadow: 0px 5px 12px 0px rgb(0 0 0 / 44%);">
      <div style="overflow-y:scroll;height:350px !important;padding-bottom: 200px;" *ngIf="clienteserviceParam.mixAndMachMontoAhorro==0">
        <div *ngFor="let item of clienteserviceParam.ofertasComerciales.ofertaComercial; let i = index">
          <div class="oferta" *ngIf="item.bienestarMixAndMatchFlg==='0' && clienteserviceParam.mixAndMachMontoAhorro==0 && (clienteserviceParam.datosPrecalificacion.segmento=='PV'|| item.tipo !== 'Solicitud')">
            <div class="row">
              <div class="col-md-3">
                <h1>{{item.tipo}}</h1>
              </div>
              <div class="col-md-8">
                <div class="row" style="padding: 0 10px 0 10px;">
                  <div class="col-md-6">
                    <h3>Monto</h3>
                    <h3>Cuota con seguro</h3>
                    <h3>Plazo</h3>
                  </div>
                  <div class="col-md-6">
                    <h2 style="text-align: right;">
                      {{item.monto|
                      currency:"Q "}}</h2>
                    <h2 style="text-align: right;">{{item.cuotaNuevoCreditoConSeguro| currency:"Q "}}</h2>
                    <h2 style="text-align: right;">{{item.plazo}} meses</h2>
                  </div>
                </div>
              </div>
              <div class="col-md-1">
                <div class="custom-control custom-switch">
                  <input *ngIf="ofertaseleccionada!=i" type="checkbox" (change)="selectOferta(i)"
                         class="custom-control-input" id="{{i}}">
                  <input *ngIf="ofertaseleccionada==i" type="checkbox" (change)="selectOferta(i)"
                         class="custom-control-input" id="{{i}}" checked disabled>
                  <label class="custom-control-label" for="{{i}}"></label>
                </div>
                <span *ngIf="listindexactive.includes(i) && !clienteserviceParam.rolABFlag" (click)="changeindexactive(i)" class="icon icon-up"
                      style="width: 22.5px;height: 17px;"></span>
                <span *ngIf="!listindexactive.includes(i) && !clienteserviceParam.rolABFlag" (click)="changeindexactive(i)" class="icon icon-down"
                      style="width: 22.5px;height: 17px;"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div style="text-align: left;"  *ngIf="clienteserviceParam.mixAndMachMontoAhorro==0">
            <button class="btn round-button-back" (click)="goBack()">Regresar</button>
          </div>
        </div>
        <div class="col-md-6">
          <div style="text-align: right;">
            <button class="btn round-button" (click)="goToSeleccion()">Continuar</button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="clienteserviceParam.datosCliente.needCoDebtor">
      <div class="oferta">
        <div class="row">
          <div class="col-md-12 text-center">
            <i class="bi bi-exclamation-octagon-fill alert-icon"></i>
          </div>
          <div class="col-md-12 text-center">
            <span class="co-debtor-title">Tu proceso necesita un codeudor</span>
          </div>
          <div class="col-md-12 text-center">
            <span class="co-debtor-p">Para continuar la precalificación, es necesario que agregues los datos de un codeudor a continuación.</span>
          </div>
          <div class="col-md-12 text-center">
            <button class="btn round-button" (click)="showDpiAlert()">Continuar</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div style="text-align: left;">
            <button class="btn round-button-back" (click)="goBack()">Regresar</button>
          </div>
        </div>
        <div class="col-md-6">
          <div style="text-align: right;">
            <button class="btn round-button"  (click)="finishDebtorFlow()">Finalizar</button>
          </div>
        </div>
      </div>
    </div>

</div>
